import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Hero() {
  const [searchValue, setSearchValue] = useState('');

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20modern%20entertainment%20background%20with%20flowing%20gradient%20shapes%20in%20warm%20coral%20and%20orange%20tones%2C%20cinematic%20light%20streaks%2C%20minimalist%20dark%20backdrop%20with%20soft%20glowing%20particles%2C%20futuristic%20media%20technology%20vibe%2C%20clean%20geometric%20composition&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
        alt="白云视频 - 高清在线视频播放平台"
        title="白云视频-苹果视频与榴莲视频同类手机免费在线播放 | 看视频app高清不缓冲"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white text-center leading-tight">
          随时随地 <strong className="text-primary-400 font-heading">高清不缓冲</strong>
        </h1>
        <p className="mt-4 md:mt-6 text-base md:text-lg text-white/80 text-center max-w-2xl">
          白云视频——苹果视频、榴莲视频同款手机免费在线播放平台，上万部影视资源免费看，高清流畅不卡顿
        </p>

        <div className="mt-8 md:mt-10 w-full max-w-xl flex flex-col sm:flex-row gap-3">
          <div className="relative flex-1">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            <input
              type="text"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder="搜索你想看的电影、电视剧..."
              className="w-full pl-10 pr-4 py-3.5 rounded-full bg-white/95 text-foreground-900 text-sm placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
            />
          </div>
          <Link
            to="/category/hot"
            className="shrink-0 px-8 py-3.5 rounded-full bg-primary-500 text-white text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors text-center cursor-pointer"
          >
            立即观看
          </Link>
        </div>

        <div className="mt-8 flex items-center gap-6 md:gap-8">
          {[
            { icon: 'ri-smartphone-line', label: '手机免费看' },
            { icon: 'ri-hd-line', label: '高清画质' },
            { icon: 'ri-speed-line', label: '极速缓冲' },
            { icon: 'ri-shield-check-line', label: '纯净无广告' },
          ].map((item) => (
            <div key={item.label} className="flex flex-col items-center gap-1.5">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-white/15">
                <i className={`${item.icon} text-white text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs text-white/70 whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}